import LoanVolumeChartComponent from './components/loan_volume_chart';
import store from '~/base_store';
import loanReportModule from '~/bundles/loan_report/store';

$(() => {
    const $el = $('#vue-loan-volume-chart');
    window.gl = window.gl || {};

    if (gl.LoanVolumeChartApp) {
        gl.LoanVolumeChartApp.$destroy(true);
    }

    if ($el.length) {
        store.registerModule('loanReport', loanReportModule);
        gl.LoanVolumeChartApp = new LoanVolumeChartComponent({
            store,
            el: $el.get(0),
        });
    }
});